module.exports = __webpack_public_path__ + "img/s3.9d5e932a.png";